import { useState } from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { Switch } from '@/components/ui/switch';

const TimePicker = ({ onChange }) => {
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('00');
  const [isPM, setIsPM] = useState(false);
  const [isHoursOpen, setIsHoursOpen] = useState(false);
  const [isMinutesOpen, setIsMinutesOpen] = useState(false);

  const handleChange = (newHours, newMinutes, newIsPM) => {
    onChange(
      `${newHours.toString().padStart(2, '0')}:${newMinutes} ${newIsPM ? 'PM' : 'AM'}`
    );
  };

  return (
    <div className="relative flex items-center space-x-2">
      {(isHoursOpen || isMinutesOpen) && (
        <div
          className="fixed inset-0 bg-black/50 z-[50]"
          onClick={() => {
            setIsHoursOpen(false);
            setIsMinutesOpen(false);
          }}
        />
      )}
      <div className="relative z-[50]">
        <Select
          value={hours.toString()}
          onValueChange={(v) => {
            const newHours = parseInt(v);
            setHours(newHours);
            handleChange(newHours, minutes, isPM);
          }}
          onOpenChange={setIsHoursOpen}
        >
          <SelectTrigger className="w-[80px]">
            <SelectValue placeholder="HH" />
          </SelectTrigger>
          <SelectContent>
            {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
              <SelectItem key={h} value={h.toString()}>
                {h.toString().padStart(2, '0')}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <span>:</span>
      <div className="relative z-[50]">
        <Select
          value={minutes}
          onValueChange={(v) => {
            const newMinutes = v;
            setMinutes(newMinutes);
            handleChange(hours, newMinutes, isPM);
          }}
          onOpenChange={setIsMinutesOpen}
        >
          <SelectTrigger className="w-[80px]">
            <SelectValue placeholder="MM" />
          </SelectTrigger>
          <SelectContent>
            {Array.from({ length: 4 }, (_, i) => i * 15).map((m) => (
              <SelectItem key={m} value={m.toString().padStart(2, '0')}>
                {m.toString().padStart(2, '0')}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center space-x-2">
        <Switch
          checked={isPM}
          onCheckedChange={(checked) => {
            setIsPM(checked);
            handleChange(hours, minutes, checked);
          }}
        />
        <Label>{isPM ? 'PM' : 'AM'}</Label>
      </div>
    </div>
  );
};

export default TimePicker;
